/* eslint-disable max-lines */
/* eslint-disable no-nested-ternary */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  Typography,
} from '@mui/material';
import { ChangeEvent, useContext, useEffect } from 'react';
import { PatternFormat } from 'react-number-format';

import {
  ClientKind,
  convertRegistrationUf,
  EvaluationType,
  HiveRequestAcceptanceStatus,
  InspectionType,
} from '../../api/enumerations';
import { AllAttachments } from '../../components/AllAttachments';
import ConfirmationDeleteDialog from '../../components/ConfirmationDeleteDialog';
import {
  CustomTextField,
  NumericTextField,
  SelectTextField,
} from '../../components/CustomInput';
import StandardMap from '../../components/Maps/StandardMap';
import MapSearchButton from '../../components/MapSearchButton';
import { MessagesDialog } from '../../components/Messages';
import { AccordionTitle } from '../../components/Sections/AccordionTitle';
import { AssociatedWorkOrders } from '../../components/Sections/AssociatedWorkOrders';
import { ClientData } from '../../components/Sections/ClientData';
import { HiveDeadlineBar } from '../../components/Sections/HiveDeadlineBar';
import { WorkOrderProgressBar } from '../../components/Sections/ProgressBar';
import { PropertyAddressWithMaps } from '../../components/Sections/PropertyAddressWithMaps';
import { PropertyData } from '../../components/Sections/PropertyData';
import { PropertyInfo } from '../../components/Sections/PropertyInfo';
import { Title } from '../../components/Sections/Title';
import { ToogleAccordion } from '../../components/Sections/ToogleAccordion';
import { VVMResponsible } from '../../components/Sections/VVMResponsible';
import Snackbar from '../../components/Snackbar';
import {
  BoxContainer,
  CancelOsBox,
  FlexSpaceBetweenBox,
  SectionBox,
} from '../../components/UI/Box';
import { BackButton, DownloadButton } from '../../components/UI/Button';
import { GridContainer } from '../../components/UI/Grid';
import { StyledTextField } from '../../components/UI/Typography';
import { Constants } from '../../constants/entrance';
import { factorTypes } from '../../constants/evaluationTypes';
import {
  IconApartmentMS,
  IconArrowCircleLeftMS,
  IconCalendarTodayMS,
  IconDownloadMS,
  IconLocationCityMS,
  IconLocationOnMS,
  IconPersonMS,
  IconUploadMS,
} from '../../constants/icons';
import {
  parcelGroup,
  privateUnitsGroup,
  selectClientKind,
  selectConcept,
  selectEvaluationType,
  selectInspectionType,
  selectPropertyType,
  selectPropertyUse,
  SelectProps,
  selectRegistrationUf,
  selectReportFunction,
  selectReportGoal,
} from '../../constants/selectOptions';
import { GlobalContext } from '../../context/global';
import { formatPhone, isProtoBank } from '../../helpers';
import { useAccordion } from '../../hooks/useAccordion';
import { useCancelWorkOrder } from '../../hooks/useCancelWorkOrder';
import useGeneral from '../../hooks/useGeneral';
import NewPropertyButtons from './components/NewPropertyButtons';
import SubmitButtons from './components/SubmitButtons';
import {
  ButtonBox,
  ButtonContainer,
  ButtonTitle,
  InputBox,
  SectionTitle,
  UploadButton,
} from './styles';
import useEntrance from './useEntrance';

export function Entrance(): JSX.Element {
  const { openSnackbar, isHiveOwner } = useContext(GlobalContext);
  const { handleCancelWorkOrder } = useCancelWorkOrder();
  const { osId, navigateHome, handleDownloadFile } = useGeneral();
  const {
    expandOne,
    setExpandOne,
    expandTwo,
    setExpandTwo,
    expandFour,
    setExpandFour,
    expandAll,
    setExpandAll,
    toggleAccordions,
  } = useAccordion();
  const {
    handleSubmit,
    verifyCep,
    handleFileUpload,
    handleRemoveRequest,
    address,
    setAddress,
    addressNumber,
    setAddressNumber,
    isWithoutNumber,
    setIsWithoutNumber,
    cep,
    setCep,
    cepError,
    city,
    setCity,
    client,
    setClient,
    clientType,
    setClientType,
    complement,
    setComplement,
    concept,
    setConcept,
    district,
    setDistrict,
    evaluationType,
    setEvaluationType,
    goal,
    setGoal,
    judicialDistrict,
    setJudicialDistrict,
    propertyFunction,
    setPropertyFunction,
    propertyType,
    setPropertyType,
    propertyUse,
    setPropertyUse,
    registerNumber,
    setRegisterNumber,
    registryOffice,
    setRegistryOffice,
    book,
    setBook,
    registrationUf,
    setRegistrationUf,
    setRequiresInspection,
    solicitor,
    setSolicitor,
    uf,
    setUf,
    zone,
    setZone,
    propertyData,
    registerFileName,
    iptuFileName,
    createdAt,
    downloadIptu,
    downloadRegister,
    referenceNumber,
    newProperty,
    searchMap,
    setSearchMap,
    isAddressEdited,
    setIsAddressEdited,
    hasSearched,
    setHasSearched,
    pinPlace,
    setPinPlace,
    submitLoading,
    removeRequestLoading,
    inspectionType,
    setInspectionType,
    builtArea,
    setBuiltArea,
    totalArea,
    setTotalArea,
    responsibleName,
    setResponsibleName,
    emailResponsible,
    setEmailResponsible,
    phoneResponsible,
    setPhoneResponsible,
    completedSections,
    shouldAssociate,
    setShouldAssociate,
    setAssociateIds,
    associatedWorkData,
  } = useEntrance();

  const isOSCreatedByHive = propertyData && propertyData.hive_request !== null;
  const isProtoBankCompany = isProtoBank();
  const showClientKind = !isHiveOwner || isProtoBankCompany;
  const isOSAccepted =
    (isOSCreatedByHive &&
      propertyData.hive_request?.acceptance_status ===
        HiveRequestAcceptanceStatus.ACCEPTED) ||
    propertyData?.hive_request?.acceptance_status ===
      HiveRequestAcceptanceStatus.ACCEPTED_WITH_PENDING;
  const isParcelGroup = parcelGroup.has(propertyType);
  const isPrivateUnit = privateUnitsGroup.has(propertyType);
  const hasAssociation = associatedWorkData.length > 0;

  useEffect(() => {
    if (expandOne && expandTwo && expandFour) {
      setExpandAll(true);
    } else {
      setExpandAll(false);
    }
  }, [expandOne, expandTwo, expandFour, setExpandAll]);

  useEffect(() => {
    setTimeout(() => {
      setExpandOne(true);
    }, 2000);
  }, []);
  useEffect(() => {
    setExpandTwo(true);
    setExpandFour(true);
  }, []);

  const handleEvaluationOptions = (): SelectProps[] => {
    return selectEvaluationType(isHiveOwner);
  };

  const handleInspectionOptions = (): SelectProps[] => {
    const requiredInPersonInspection = [
      EvaluationType.COMPLETEFACTORS,
      EvaluationType.COMPLETEINFERENCES,
    ];
    if (requiredInPersonInspection.includes(evaluationType)) {
      return selectInspectionType(false);
    }
    return selectInspectionType();
  };

  return (
    <GridContainer>
      <BackButton onClick={navigateHome}>{IconArrowCircleLeftMS}</BackButton>
      <BoxContainer component="form" id="entrance" onSubmit={handleSubmit}>
        <Title
          osNumber={referenceNumber}
          title={newProperty ? Constants.dataEntrance : Constants.dataEdition}
          newOs={newProperty}
          createdAt={createdAt}
        />
        {isOSCreatedByHive &&
          !newProperty &&
          propertyData &&
          propertyData.hive_request && (
            <HiveDeadlineBar
              slaStatus={propertyData.sla_status}
              slaDaysElapsed={propertyData.sla_days_elapsed}
              slaDaysRemaining={propertyData.sla_days_remaining}
              requestCreatedAt={propertyData.hive_request.created_at}
              requestLimitDate={propertyData.hive_request.complete_until}
            />
          )}
        <FlexSpaceBetweenBox>
          <CancelOsBox>
            {!newProperty && (
              <ConfirmationDeleteDialog
                iconCancel
                title={Constants.cancelOs}
                text={Constants.cancelOsText}
                modalCallback={handleCancelWorkOrder}
              />
            )}
          </CancelOsBox>
          <Box display="flex" gap={1.2}>
            {isHiveOwner && isOSCreatedByHive && (
              <MessagesDialog
                osId={osId}
                hiveRequest={propertyData.hive_request || undefined}
              />
            )}
            <AllAttachments propertyData={propertyData} osId={osId} />
          </Box>
        </FlexSpaceBetweenBox>
        <WorkOrderProgressBar complete={completedSections.reportData}>
          {isHiveOwner && isOSAccepted ? (
            <ClientData propertyData={propertyData} />
          ) : (
            <SectionBox>
              <SectionTitle>
                {IconPersonMS}
                {Constants.reportData}
              </SectionTitle>
              <InputBox>
                <CustomTextField
                  required
                  id="client"
                  label={
                    isHiveOwner
                      ? 'proponente / cliente'
                      : 'proprietário do imóvel'
                  }
                  value={client}
                  setValue={setClient}
                />
                {showClientKind && (
                  <SelectTextField
                    required
                    id="client-type"
                    label="tipo do cliente"
                    value={clientType}
                    setValue={(value) => {
                      setClientType(value);
                      setEvaluationType(0);
                      if (value === ClientKind.BRASIL_BANK) {
                        setSolicitor('Banco do Brasil');
                      } else if (value === ClientKind.CAIXA) {
                        setSolicitor('Caixa Econômica');
                      } else setSolicitor('');
                    }}
                    selectOptions={selectClientKind()}
                  />
                )}
                <SelectTextField
                  required
                  id="os-goal"
                  label="objetivo"
                  value={goal}
                  setValue={setGoal}
                  selectOptions={selectReportGoal()}
                />
                {!showClientKind && (
                  <CustomTextField
                    required
                    id="solicitor"
                    label="solicitante"
                    value={solicitor}
                    setValue={setSolicitor}
                  />
                )}
              </InputBox>
              <InputBox>
                {showClientKind && (
                  <CustomTextField
                    required
                    id="solicitor"
                    label="solicitante"
                    value={solicitor}
                    setValue={setSolicitor}
                  />
                )}
                <SelectTextField
                  required
                  id="os-function"
                  label="finalidade"
                  value={propertyFunction}
                  setValue={setPropertyFunction}
                  selectOptions={selectReportFunction()}
                />
                <SelectTextField
                  required
                  id="property-use"
                  label="uso do imóvel"
                  value={propertyUse}
                  setValue={setPropertyUse}
                  selectOptions={selectPropertyUse()}
                />
                <SelectTextField
                  required
                  id="evaluation-type"
                  label="tipo do cálculo"
                  value={evaluationType}
                  setValue={(value) => {
                    setEvaluationType(value);
                    setInspectionType(InspectionType.SELECT);
                    if (
                      value === EvaluationType.AUTOFACTORS ||
                      value === EvaluationType.AUTOINFERENCES
                    ) {
                      setRequiresInspection(false);
                    } else {
                      setRequiresInspection(true);
                    }
                  }}
                  selectOptions={handleEvaluationOptions()}
                />
              </InputBox>
              {isHiveOwner && (
                <Grid container>
                  <Grid item xs={3.8}>
                    <SelectTextField
                      required
                      id="inspection-type"
                      label="modalidade da vistoria"
                      value={inspectionType}
                      setValue={setInspectionType}
                      selectOptions={handleInspectionOptions()}
                    />
                  </Grid>
                </Grid>
              )}
            </SectionBox>
          )}
        </WorkOrderProgressBar>
        <WorkOrderProgressBar complete={completedSections.propertyData}>
          <>
            <SectionBox>
              <SectionTitle>
                {IconApartmentMS}
                {Constants.propertyData}
              </SectionTitle>
              {isHiveOwner && isOSAccepted ? (
                <PropertyData propertyData={propertyData} />
              ) : (
                <>
                  <Typography>{Constants.uploadText}</Typography>
                  <ButtonContainer>
                    <ButtonBox>
                      <ButtonTitle>{Constants.propertyRegister}</ButtonTitle>
                      {downloadRegister.length > 0 ? (
                        <DownloadButton
                          onClick={() => {
                            if (downloadRegister)
                              handleDownloadFile(downloadRegister, 'matricula');
                          }}
                        >
                          {IconDownloadMS}
                          {Constants.download}
                        </DownloadButton>
                      ) : (
                        <>
                          <label htmlFor="uploadRegister">
                            <input
                              accept="image/*,application/pdf"
                              id="uploadRegister"
                              type="file"
                              style={{ display: 'none' }}
                              onChange={async (
                                e: ChangeEvent<HTMLInputElement>
                              ) => handleFileUpload(e, 'register')}
                            />
                            <UploadButton variant="contained" component="span">
                              {IconUploadMS}
                              {Constants.upload}
                            </UploadButton>
                          </label>
                          <Box height="20px" mt={1}>
                            {registerFileName}
                          </Box>
                        </>
                      )}
                    </ButtonBox>
                    <ButtonBox>
                      <ButtonTitle>{Constants.iptu}</ButtonTitle>
                      {downloadIptu.length > 0 ? (
                        <DownloadButton
                          onClick={() => {
                            if (downloadIptu)
                              handleDownloadFile(downloadIptu, 'iptu');
                          }}
                        >
                          {IconDownloadMS}
                          {Constants.download}
                        </DownloadButton>
                      ) : (
                        <>
                          <label htmlFor="uploadIptu">
                            <input
                              accept="image/*,application/pdf"
                              id="uploadIptu"
                              type="file"
                              style={{ display: 'none' }}
                              onChange={async (
                                e: ChangeEvent<HTMLInputElement>
                              ) => handleFileUpload(e, 'iptu')}
                            />
                            <UploadButton variant="contained" component="span">
                              {IconUploadMS}
                              {Constants.upload}
                            </UploadButton>
                          </label>
                          <Box height="20px" mt={1}>
                            {iptuFileName}
                          </Box>
                        </>
                      )}
                    </ButtonBox>
                  </ButtonContainer>
                  <InputBox>
                    <CustomTextField
                      required
                      disabled={hasAssociation}
                      id="register-number"
                      label="nº da matrícula"
                      value={registerNumber}
                      setValue={setRegisterNumber}
                    />
                    <CustomTextField
                      required
                      disabled={hasAssociation}
                      id="registry-office"
                      label="código do cartório (cns)"
                      value={registryOffice}
                      setValue={setRegistryOffice}
                    />
                    <CustomTextField
                      required
                      disabled={hasAssociation}
                      id="register-number"
                      label="livro de registro"
                      value={book}
                      setValue={setBook}
                    />
                    <SelectTextField
                      required
                      id="property-type"
                      label="tipo do imóvel"
                      value={propertyType}
                      setValue={(value) => {
                        setPropertyType(value);
                        if (
                          parcelGroup.has(value) &&
                          factorTypes.includes(evaluationType)
                        ) {
                          setEvaluationType(0);
                        }
                      }}
                      selectOptions={selectPropertyType()}
                    />
                  </InputBox>
                  {!isHiveOwner && (
                    <InputBox>
                      <SelectTextField
                        required
                        id="concept"
                        label="conceito do espaço"
                        value={concept}
                        setValue={setConcept}
                        selectOptions={selectConcept()}
                      />
                      <NumericTextField
                        required
                        id="zone"
                        label="ofício/zona"
                        suffix=""
                        maxLength={12}
                        value={zone}
                        setValue={setZone}
                      />
                      <CustomTextField
                        required
                        id="judicial-district"
                        label="comarca"
                        value={judicialDistrict}
                        setValue={setJudicialDistrict}
                      />
                      <SelectTextField
                        required
                        id="registration-uf"
                        label="UF"
                        value={registrationUf}
                        setValue={setRegistrationUf}
                        selectOptions={selectRegistrationUf()}
                      />
                    </InputBox>
                  )}
                </>
              )}
            </SectionBox>
            <ToogleAccordion expand={expandAll} toogle={toggleAccordions} />
          </>
        </WorkOrderProgressBar>
        <WorkOrderProgressBar
          complete={completedSections.propertyAddress}
          lastAccordion={!isHiveOwner}
        >
          <SectionBox>
            <AccordionTitle
              title={Constants.propertyAddress}
              icon={IconLocationOnMS}
              openAccordion={expandOne}
              setOpenAccordion={setExpandOne}
            />
            {expandOne &&
              (isHiveOwner && isOSAccepted ? (
                <PropertyAddressWithMaps propertyData={propertyData} />
              ) : (
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Grid container spacing={{ xs: 2.5, xl: 4 }}>
                      <Grid item xs={4}>
                        <PatternFormat
                          required
                          format="#####-###"
                          mask="_"
                          customInput={StyledTextField}
                          id="cep"
                          label="CEP"
                          value={cep}
                          onInvalid={(e: ChangeEvent<HTMLInputElement>) =>
                            e.target.setCustomValidity('Preencha este campo')
                          }
                          onInput={(e: ChangeEvent<HTMLInputElement>) =>
                            e.target.setCustomValidity('')
                          }
                          error={cepError}
                          onChange={(e: ChangeEvent<HTMLInputElement>) => {
                            setCep(e.target.value);
                            verifyCep(e.target.value);
                          }}
                        />
                      </Grid>
                      <Grid item xs={8}>
                        <CustomTextField
                          required
                          id="address"
                          label="logradouro"
                          value={address}
                          setValue={setAddress}
                          onChange={setIsAddressEdited}
                        />
                      </Grid>
                      <Grid item xs={4}>
                        <CustomTextField
                          required
                          id="address-number"
                          label="número"
                          disabled={isWithoutNumber}
                          value={addressNumber}
                          setValue={setAddressNumber}
                          onChange={setIsAddressEdited}
                        />
                      </Grid>
                      <Grid item xs={3} mt="6px">
                        <FormControlLabel
                          id="without-number"
                          label="Sem número"
                          control={
                            <Checkbox
                              name="without-number"
                              checked={isWithoutNumber}
                              onChange={(event) => {
                                setIsWithoutNumber(event.target.checked);
                                setIsAddressEdited(true);
                                if (event.target.checked) setAddressNumber('');
                              }}
                            />
                          }
                          sx={{
                            '& .MuiTypography-root': {
                              fontSize: '14px',
                              lineHeight: 1.2,
                            },
                          }}
                        />
                      </Grid>
                      <Grid item xs={5}>
                        <CustomTextField
                          id="complement"
                          label="complemento"
                          value={complement}
                          setValue={setComplement}
                          onChange={setIsAddressEdited}
                        />
                      </Grid>
                      <Grid item xs={4.5}>
                        <CustomTextField
                          required
                          id="district"
                          label="bairro"
                          value={district}
                          setValue={setDistrict}
                          onChange={setIsAddressEdited}
                        />
                      </Grid>
                      <Grid item xs={5}>
                        <CustomTextField
                          required
                          id="city"
                          label="cidade"
                          value={city}
                          setValue={setCity}
                          onChange={setIsAddressEdited}
                        />
                      </Grid>
                      <Grid item xs={2.5}>
                        <SelectTextField
                          id="uf"
                          label="estado"
                          value={uf}
                          setValue={(v) => {
                            setUf(v as number);
                            setIsAddressEdited(true);
                          }}
                          selectOptions={selectRegistrationUf()}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <MapSearchButton
                          cep={cep}
                          address={address}
                          addressNumber={addressNumber}
                          district={district}
                          city={city}
                          uf={uf}
                          isWithoutNumber={isWithoutNumber}
                          hasSearched={hasSearched}
                          isAddressEdited={isAddressEdited}
                          labels={{
                            searchMap: Constants.searchMap,
                            mapUpdated: Constants.mapUpdated,
                            fieldsIncomplete: Constants.fieldsIncomplete,
                          }}
                          onClick={() => {
                            setSearchMap(!searchMap);
                            setIsAddressEdited(false);
                            setHasSearched(true);
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={6}>
                    <StandardMap
                      searchMap={searchMap}
                      address={`${address} ${addressNumber}`}
                      district={district}
                      city={city}
                      uf={convertRegistrationUf(uf)}
                      pinPlace={pinPlace}
                      setPinPlace={setPinPlace}
                      showCoords
                    />
                  </Grid>
                </Grid>
              ))}
          </SectionBox>
        </WorkOrderProgressBar>
        {isHiveOwner && (
          <WorkOrderProgressBar
            complete={completedSections.propertyDetails}
            lastAccordion={inspectionType !== InspectionType.REMOTE}
          >
            <SectionBox>
              <AccordionTitle
                title={Constants.propertyDetails}
                icon={IconLocationCityMS}
                openAccordion={expandTwo}
                setOpenAccordion={setExpandTwo}
              />
              {expandTwo &&
                (isOSAccepted ? (
                  <PropertyInfo propertyData={propertyData} />
                ) : !isParcelGroup ? (
                  <Box width="200px">
                    <NumericTextField
                      required
                      id="built-area"
                      label={
                        isPrivateUnit ? 'área privativa' : 'área construída'
                      }
                      suffix=" m²"
                      decimalSeparator=","
                      decimalScale={2}
                      maxLength={18}
                      value={builtArea}
                      setValue={setBuiltArea}
                    />
                  </Box>
                ) : (
                  <Grid container spacing={2}>
                    <Grid item xs={2}>
                      <NumericTextField
                        id="total-area"
                        label="área do terreno"
                        suffix=" m²"
                        decimalSeparator=","
                        decimalScale={2}
                        maxLength={18}
                        value={totalArea}
                        setValue={setTotalArea}
                        disable={isHiveOwner}
                      />
                    </Grid>
                  </Grid>
                ))}
            </SectionBox>
          </WorkOrderProgressBar>
        )}
        {isHiveOwner && inspectionType === InspectionType.REMOTE && (
          <WorkOrderProgressBar
            complete={completedSections.scheduleResponsibleData}
            lastAccordion
          >
            <SectionBox>
              <SectionBox id="schedule-responsible-data">
                <AccordionTitle
                  title={Constants.scheduleResponsibleData}
                  icon={IconCalendarTodayMS}
                  openAccordion={expandFour}
                  setOpenAccordion={setExpandFour}
                />
                {expandFour &&
                  (isOSAccepted ? (
                    <VVMResponsible propertyData={propertyData} />
                  ) : (
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <Grid container spacing={4}>
                          <Grid item xs={4}>
                            <CustomTextField
                              required
                              id="responsible-name"
                              label="Responsável"
                              value={responsibleName}
                              setValue={setResponsibleName}
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <CustomTextField
                              id="email-responsible"
                              label="Email responsável"
                              value={emailResponsible}
                              setValue={setEmailResponsible}
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <StyledTextField
                              required
                              id="phone-responsible"
                              label="Telefone responsável"
                              inputProps={{ maxLength: 15 }}
                              value={phoneResponsible}
                              onChange={(e: ChangeEvent<HTMLInputElement>) =>
                                setPhoneResponsible(formatPhone(e.target.value))
                              }
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  ))}
              </SectionBox>
            </SectionBox>
          </WorkOrderProgressBar>
        )}
        <AssociatedWorkOrders osId={osId} list={associatedWorkData} />
        {newProperty ? (
          <NewPropertyButtons
            book={book}
            registerNumber={registerNumber}
            registryOffice={registryOffice}
            shouldAssociate={shouldAssociate}
            handleAssociate={setShouldAssociate}
            submitLoading={submitLoading}
            setAssociateIds={setAssociateIds}
          />
        ) : (
          <SubmitButtons
            isHiveOwner={isHiveOwner}
            osId={osId}
            referenceNumber={referenceNumber}
            submitLoading={submitLoading}
            isOSAccepted={isOSAccepted}
            isOSRejected={
              propertyData?.hive_request?.acceptance_status ===
              HiveRequestAcceptanceStatus.REJECTED
            }
            removeRequestLoading={removeRequestLoading}
            handleRemoveRequest={handleRemoveRequest}
            book={book}
            registerNumber={registerNumber}
            registryOffice={registryOffice}
            shouldAssociate={shouldAssociate}
            handleAssociate={setShouldAssociate}
            setAssociateIds={setAssociateIds}
            hasAssociation={hasAssociation}
          />
        )}
      </BoxContainer>
      {openSnackbar && <Snackbar />}
    </GridContainer>
  );
}
